import { render } from "./workerinfo.vue?vue&type=template&id=60206941&scoped=true&ts=true"
import script from "./workerinfo.vue?vue&type=script&lang=ts"
export * from "./workerinfo.vue?vue&type=script&lang=ts"

import "./workerinfo.vue?vue&type=style&index=0&id=60206941&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60206941"]])

export default __exports__